// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__23KXw","productName":"Table_productName__3JYaa"};